import * as React from "react"
import { cn } from "../../lib/utils"

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, onClick, disabled, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-10 w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-secondary-foreground placeholder:text-gray-400 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring focus-visible:border-ring disabled:cursor-not-allowed disabled:opacity-50",
          className
        )}
        ref={ref}
        disabled={disabled}
        onClick={(e) => {
          onClick?.(e);
          // A native date/time input's calendar/clock icon is the only
          // spot that opens the picker by default -- clicking the rest of
          // the field (the day/month/year text itself) just moves the
          // segment caret. showPicker() makes a click anywhere in the
          // field open it too, matching every other field's full-field
          // click target. Single source: every date/time input in the app
          // renders through this component.
          if ((type === 'date' || type === 'time') && !disabled) {
            try {
              (e.currentTarget as HTMLInputElement & { showPicker?: () => void }).showPicker?.();
            } catch {
              // Unsupported browser, or not called from a user gesture --
              // the native icon click-to-open still works regardless.
            }
          }
        }}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input } 